<template>
  <rest-page ref="restPage" :fetch-endpoint="fetchEndpoint">
    <page-header-new :title="pageTitle" :breadcrumbs="breadcrumbs">
      <template v-slot:actions>
        <el-button
          type="primary"
          class="btn-connect btn-custom-icon"
          @click="save"
        >
          <icon class="icon" glyph="app-lightning" style="margin-right: 12px" />
          {{ $t('RestForm_Update') }}
        </el-button>
      </template>
    </page-header-new>

    <page-content>
      <rest-form
        ref="form"
        :save-endpoint="saveEndpoint"
        :model="model"
        v-if="model"
      >
        <InappPollingSettings :model="model" />
      </rest-form>
    </page-content>
  </rest-page>
</template>

<script>
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestPage from '@/common/components/rest/RestPage'
import PageContent from '@/common/components/page/PageContent'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import RestForm from '@/common/components/rest/RestForm'
import InappPollingSettings from '@/modules/settings/components/InappPollingSettings'

export default {
  name: 'ApplicationInappPage',
  components: {
    InappPollingSettings,
    RestForm,
    PageContent,
    RestPage,
    PageHeaderNew
  },
  data() {
    return {
      model: null
    }
  },
  computed: {
    typeTitle() {
      if (this.model) {
        if (this.model.type === 'web') {
          return this.$t('Channels_OnsiteSettings')
        } else {
          return this.$t('Channels_InappSettings')
        }
      } else {
        return ''
      }
    },

    pageTitle() {
      return `${this.applicationName} - ${this.typeTitle}`
    },

    breadcrumbs() {
      return [
        {
          label: this.$t('ApplicationList_Title'),
          route: projectRoute({
            name: 'Applications'
          })
        },
        {
          label: this.applicationName,
          route: projectRoute({
            name: 'ApplicationChannels',
            query: {
              id: this.$route.query.id,
              project_id: this.$route.query.project_id
            }
          })
        },
        {
          label: this.typeTitle
        }
      ]
    },

    applicationName() {
      if (this.model && this.model.name) {
        return this.model.name
      } else {
        return null
      }
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `applications/${this.$route.query.id}`,
        handler: data => {
          this.model = data
        }
      })
    },

    saveEndpoint() {
      if (this.$route.query.id) {
        return projectEndpoint({
          method: 'patch',
          url: `applications/${this.$route.query.id}`
        })
      }
    }
  },

  methods: {
    save() {
      this.$refs['form'].save()
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/account/pages/ApplicationInappPage.vue